export default {
  applicationSettings: [],
  applicationSetting: undefined,
};
